import React, { useState, useEffect } from "react"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import Table from "./Table"
import Skeleton from "react-loading-skeleton"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { getFabricTradingResource } from "store/actions"
import { useHistory } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import { CustomPagination } from "components/Common/Pagination"

export default function FabricTradingCompany() {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useSelector(({ fabricTreding }) => fabricTreding)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [count, setCount] = useState(100)
  const [filter, setFilter] = useState({
    name: "",
    manager: "",
    phone: "",
    email: "",
  })

  const onFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({
      page: 0,
      size: 10,
    })
    dispatch(getFabricTradingResource({ ...filter, page: 0, size: 10 }))
  }

  useEffect(() => {
    if (store.status === "success") {
      setCount(store?.data?.totalPages)
    }
  }, [store?.data])

  useEffect(() => {
    dispatch(getFabricTradingResource({ ...filter, ...pagination }))
  }, [dispatch, pagination])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"生地商社マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={2}>
                <TextInputWithLabel
                  label={"商社名"}
                  placeholder={""}
                  value={filter.name}
                  type="text"
                  name="name"
                  onChange={onFilter}
                />
              </Col>
              <Col md={2}>
                <TextInputWithLabel
                  label={"担当者"}
                  placeholder={""}
                  value={filter.manager}
                  type="text"
                  name="manager"
                  onChange={onFilter}
                />
              </Col>
              <Col md={2}>
                <TextInputWithLabel
                  label={"メール"}
                  placeholder={""}
                  value={filter.email}
                  type="text"
                  name="email"
                  onChange={onFilter}
                />
              </Col>
              <Col md={2}>
                <TextInputWithLabel
                  label={"電話番号"}
                  placeholder={""}
                  value={filter.phone}
                  type="text"
                  name="phone"
                  onChange={onFilter}
                />
              </Col>

              <Col md={4} className="align-self-end">
                <SButton onClick={onSearch} className={"mx-2 button"}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-end align-self-end mb-3">
              <SButton
                className="button"
                onClick={() =>
                  history.push("/master/fabric-trading-company/create")
                }
              >
                新規追加
              </SButton>
            </div>
            <Row className="mt-3">
              <Col>
                {store.status === "process" ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <Table
                      content={store.data.content}
                      page={pagination.page}
                      size={pagination.size}
                      count={count}
                      setParams={setPagination}
                      params={pagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
